import React from "react";

const Details = ({ classes, value, unit }) => {
  return (
    <div className={classes.container}>
      {value}
      <span className={classes.unitStyle}>{unit}</span>
    </div>
  );
};

export default Details;
